import React from 'react';
import { ErrorLayout } from '@layouts';
import { ErrorStub } from '@components/Error-Stub';
import { getErrorContent } from '@libs';

// todo непорядок с повторяющимся getErrorContent
const Error = ({ statusCode }) => <ErrorStub error={getErrorContent(statusCode)} />;

Error.getLayout = (page) => {
  const { title } = getErrorContent({ code: page.props.statusCode });
  const { translations } = page.props;

  return <ErrorLayout title={translations.t(title)}>{page}</ErrorLayout>;
};

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;

  return { statusCode };
};

export default Error;
